import React from 'react'
import './Sidebar.css'
import pikku from './pikku.jpeg'

function Sidebaar(props) {

  return (
        <>
        
        <div id="sideBar1" style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`}} >

        <div className={`form-check form-switch text-${props.mode==='light'?'light':'dark'}`}>
  <input className="form-check-input" onClick={props.togleMode} type="checkbox" id="flexSwitchCheckDefault" />
  <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Night Mode</label>
</div>

        <div id="img"> 
        {/* <Image/> */}
        <img src={pikku} alt="" />
        
        </div >
            {/* <img id="img" src={<Image />} alt=""/> */}
            
            <h1 style={{color:`${props.mode==='light'?'white':'#000028'}`}} id="name">Digvijay Singh Chauhan </h1>

            <p style={{color:`${props.mode==='light'?'yellowgreen':'rgb(68, 100, 5)'}`}} id="field">𝖲𝗈𝖿𝗍𝗐𝖺𝗋𝖾 𝖤𝗇𝗀𝗂𝗇𝖾𝖾𝗋</p>

        <div className='detail'>
            <a  href="#di1">
                <div className="details">Profile</div>
            </a> <br />
            <a  href="#di2">
                <div className="details">Qualification</div>
            </a> <br />
            <a href="#di3">
                <div className="details">Projects </div>
            </a> <br />
            <a href="#di4">
                <div className="details">Contact Me</div>
            </a>
            </div>
        </div>
        </>
    
  )
}

export default Sidebaar
